import cloneDeep from 'lodash/cloneDeep';
import { v4 as uuidv4 } from 'uuid';

// According to Jorge, they keys 'id' and 'notes' that are associated to the
// upload element validations should not be changed/updated when copy/pasting fields.
const BLACKLISTED_KEYS = ['id', 'notes'];

export const findElementById = (root, id) => {
  if (!root) return null;
  if (root.id === id) return root;
  if (Array.isArray(root)) {
    for (const item of root) {
      const found = findElementById(item, id);
      if (found) return found;
    }
  } else if (root.properties) {
    return findElementById(root.properties, id);
  }
  return null;
};

const stripLastNumber = str => (str ? str.replace(/-\d+$/, '') : '');

const generateUniqueKey = (baseKey, usedKeys) => {
  let newKey;
  do {
    const rand = Math.trunc(Math.random() * 1000);
    newKey = `${baseKey}-${rand}`;
  } while (usedKeys.has(newKey));
  usedKeys.add(newKey);
  return newKey;
};

const generateCopiedFieldKey = (fieldElement, usedKeys = new Set()) => {
  const fieldElementCopy = cloneDeep(fieldElement);

  // Recursively update children first
  if (fieldElementCopy.properties) {
    if (Array.isArray(fieldElementCopy.properties)) {
      fieldElementCopy.properties = fieldElementCopy.properties.map(child =>
        generateCopiedFieldKey(child, usedKeys)
      );
    } else if (typeof fieldElementCopy.properties === 'object') {
      Object.keys(fieldElementCopy.properties).forEach(key => {
        fieldElementCopy.properties[key] = generateCopiedFieldKey(
          fieldElementCopy.properties[key],
          usedKeys
        );
      });
    }
  }

  // Update the id with a new UUID
  fieldElementCopy.id = uuidv4();

  // Now update the current node's key and reportingKey (and enumRef if present)
  if (
    fieldElementCopy.key &&
    !BLACKLISTED_KEYS.includes(fieldElementCopy.key)
  ) {
    fieldElementCopy.originalKey = fieldElementCopy.key;
    const baseKey = stripLastNumber(fieldElementCopy.key);
    const newKey = generateUniqueKey(baseKey, usedKeys);
    fieldElementCopy.key = newKey;

    if (fieldElementCopy.enumRef) {
      fieldElementCopy.enumRef = `${stripLastNumber(
        fieldElementCopy.enumRef
      )}-${newKey.split('-').pop()}`;
    }
    if (
      fieldElementCopy.reportingKey &&
      !fieldElementCopy.reportingKey.startsWith('contributor')
    ) {
      fieldElementCopy.reportingKey = `${stripLastNumber(
        fieldElementCopy.reportingKey
      )}-${newKey.split('-').pop()}`;
    }
  }

  return fieldElementCopy;
};

export default generateCopiedFieldKey;
